<template>
  <div v-if="text" class="message-success">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'SuccessMessage',
  props: {
    text: { type: String, default: '' },
  },
};
</script>
